import { CircularProgress } from "@mui/material";
import type { RefObject } from "react";
import MessageBubble from "./MessageBubble";
import type { ChatContact, ChatMessage } from "../types/chatTypes";

interface ChatMessagesProps {
  contact: ChatContact;
  messages: ChatMessage[];
  search: string;
  scrollRef: RefObject<HTMLDivElement | null>;
  bottomRef: RefObject<HTMLDivElement | null>;
  handleScroll: () => void;
  loadingMore: boolean;
  hasMore: boolean;
}

const ChatMessages = ({
  contact,
  messages,
  search,
  scrollRef,
  bottomRef,
  handleScroll,
  loadingMore,
  hasMore,
}: ChatMessagesProps) => {
  return (
    <div
      ref={scrollRef}
      onScroll={handleScroll}
      className="flex-1 min-h-0 overflow-y-auto bg-[#f8fafc] px-4 md:px-6 py-6 space-y-4"
      style={{
        backgroundImage: 'radial-gradient(#e2e8f0 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }}
    >
      {loadingMore && (
        <div className="flex justify-center py-2">
          <CircularProgress size={18} sx={{ color: "#2563eb" }} />
        </div>
      )}

      {!hasMore && <p className="text-center text-xs text-gray-400">No older messages</p>}

      {messages.map((msg) => (
        <MessageBubble key={msg.id} contact={contact} message={msg} search={search} />
      ))}

      <div ref={bottomRef} />
    </div>
  );
};

export default ChatMessages;
